import React from "react";
import { Link } from "react-router-dom";
// import VideoContainer from "../video-container/VideoContainer";

import "./WatchButton.scss";

const WatchButton = () => {
  return (
    <button className="movie-desc-container__watch">
      <Link to="/play">Watch</Link>
    </button>
  );
};
export default WatchButton;
